<p-fileUpload
    #uploadEl
    [ngClass]="{'ca-upload-control':!isJa, 'ca-upload-control-ja': isJa }"
    [class.has-error]="uploadMsg"
    name="file[]"
    [url]="restUrl"
    [accept]="accept"
    [allowFileSuffix]="accept"
    [uploadButtonVisible]="true"
    [maxFileSize]="maxFileSize"
    [disabled]="uploadDisabled || disabled"
    [timeout]="timeout"
    (onSelect)="onSelectPatch($event, uploadEl, onSelect)"
    (onBeforeSend)="onBeforeSend($event)"
    (onBeforeUpload)="onBeforeUpload($event)"
    (onUpload)="onUpload($event)"
    (onError)="onError()">
</p-fileUpload>
<!-- 错误信息 -->
<div>
    <div *ngIf="uploadstatus === UPLOAD_STATUS.err">
        <!-- 上传失败信息 -->
        <n-tip *ngIf="uploadMsg && !distributeFail"
            type="failed"
            [content]="uploadMsg">
        </n-tip>
        <!-- 分发失败信息 -->
        <div class="dist-tip" *ngIf="distributeFail">
            <svg class="dist-tip-icon">
                <use xlink:href="#icon-status-failed"></use>
            </svg>
            <div class="dist-tip-text">
                {{i18n.distFailTip}}
                <span class="dist-tip-text-link" (click)="showUploadFailDetail()">{{i18n.clickShowDetail}}</span>
            </div>
        </div>

    </div>
</div>
<!-- 状态 -->
<div *ngIf="uploadstatus === UPLOAD_STATUS.suc && uploadProgressShow" style="margin-top:.1rem">
    <svg class="icon icon-status">
        <use xlink:href="#icon-status-succeed"></use>
    </svg>
    {{i18n.uploadsuc}}
</div>
<!-- 进度条 -->
<div class="upload-Progress" *ngIf="uploadstatus === UPLOAD_STATUS.distributing">
    <div>
        <p-progressBar [value]="uploadProgress"  [color]="progressColor"></p-progressBar>
    </div>
    <div>
        <span class="tip-text">{{i18n.distributePack}}</span>
    </div>
</div>


